import React, { useEffect } from 'react';
import { Typography, ButtonBase } from '@material-ui/core';
import styled from 'styled-components';
import { useGetMySalesCountersQuery, useGetMySalesQuery, useLazyGetMySalesQuery } from 'services/api/sales';
import { useDispatch, useSelector } from 'react-redux';
import { setPage, setFilters } from '../../../../services/mySales/salesSlice';

const StyledTypography = styled<any>(Typography)`
  font-weight: 500;
  font-size: 16px;
  padding: 12px 13px;
  border-bottom: ${props => (props.isActive ? '3px solid #212121' : 'none')};
`;

const Tabs = () => {
  const dispatch = useDispatch();

  const { filters, page, perPage } = useSelector((state: any) => state.mySales);
  const activeTab = filters.auctionStatus;
  const auctionTab = filters.auctionType;
  const { data, refetch: refetchCounters } = useGetMySalesCountersQuery(auctionTab);
  const [refetch] = useLazyGetMySalesQuery();

  const handleTabClick = React.useCallback(
    (tab: string) => {
      dispatch(setPage(1));
      dispatch(setFilters({ auctionStatus: tab, auctionType: auctionTab }));
      refetchCounters();
      refetch({ limit: perPage, offset: 1, ...filters, auctionStatus: tab, auctionType: auctionTab });
    },
    [dispatch, auctionTab]
  );

  useEffect(() => {
    if (!data) return;
    if (data.active === 0 && data.pending === 0) return;
    if (data.active === 0 && activeTab === 'active') {
      handleTabClick('pending');
    }
    if (data.pending === 0 && activeTab === 'pending') {
      handleTabClick('active');
    }
  }, [activeTab, data, dispatch, handleTabClick]);

  return (
    <>
      {data && data.active !== 0 && (
        <ButtonBase onClick={() => handleTabClick('active')}>
          <StyledTypography variant="title" isActive={activeTab === 'active'}>
            {`Active (${data?.active ?? 0})`}
          </StyledTypography>
        </ButtonBase>
      )}
      {data && data.pending !== 0 && (
        <ButtonBase onClick={() => handleTabClick('pending')}>
          <StyledTypography variant="title" isActive={activeTab === 'pending'}>
            {`Timer Ended (${data?.pending ?? 0})`}
          </StyledTypography>
        </ButtonBase>
      )}
    </>
  );
};

export default Tabs;
